var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloudUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5 17.427c3.937-.447 7-3.873 7-8.032 0-4.464-3.526-8.082-7.875-8.082-3.428 0-6.343 2.249-7.425 5.388h-.45C2.85 6.7.5 9.113.5 12.089s2.35 5.388 5.25 5.388h3.5V15.68h-3.5c-.483 0-.943-.101-1.362-.283-1.257-.545-2.138-1.822-2.138-3.31 0-1.983 1.567-3.591 3.5-3.591h1.815c.425-3.046 2.975-5.388 6.06-5.388 3.383 0 6.125 2.814 6.125 6.286 0 3.166-2.282 5.786-5.25 6.222v1.81zm.619-5.973c.341.35.341.92 0 1.27a.859.859 0 0 1-1.238 0l-1.131-1.161v5.914a.887.887 0 0 1-.875.898.887.887 0 0 1-.875-.898v-5.914l-1.131 1.16a.86.86 0 0 1-1.238 0 .915.915 0 0 1 0-1.269l2.625-2.694a.864.864 0 0 1 .619-.263c.232 0 .455.095.619.263l2.625 2.694z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "go149lcsqa",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 22,
    height: 18
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5 17.427c3.937-.447 7-3.873 7-8.032 0-4.464-3.526-8.082-7.875-8.082-3.428 0-6.343 2.249-7.425 5.388h-.45C2.85 6.7.5 9.113.5 12.089s2.35 5.388 5.25 5.388h3.5V15.68h-3.5c-.483 0-.943-.101-1.362-.283-1.257-.545-2.138-1.822-2.138-3.31 0-1.983 1.567-3.591 3.5-3.591h1.815c.425-3.046 2.975-5.388 6.06-5.388 3.383 0 6.125 2.814 6.125 6.286 0 3.166-2.282 5.786-5.25 6.222v1.81zm.619-5.973c.341.35.341.92 0 1.27a.859.859 0 0 1-1.238 0l-1.131-1.161v5.914a.887.887 0 0 1-.875.898.887.887 0 0 1-.875-.898v-5.914l-1.131 1.16a.86.86 0 0 1-1.238 0 .915.915 0 0 1 0-1.269l2.625-2.694a.864.864 0 0 1 .619-.263c.232 0 .455.095.619.263l2.625 2.694z",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudUpload);
export default __webpack_public_path__ + "static/media/cloud-upload.e9f1f8a2f07e00634d9b128db9fcaa0c.svg";
export { ForwardRef as ReactComponent };